export default __webpack_public_path__ + "static/media/bloco_image_3.c2e1d62d.svg";